import React from 'react';

type PropsPanelSyncData = {
  dataUser: any;
}

export const SyncDataComponent = (props: PropsPanelSyncData) => {
  return (
    <>
      <div className='grid gap-4 grid-cols-8 '>
        <div className='col-span-2 flex flex-col'>


        </div>
      </div>
    </>
  );
};